export const RECLAIM_PROTOCOL_DBG_TRANS = {
  APP_ID: "0xDbDf3F8B50De8CEe3596336929Ca6B70627Dc683",
  PROVIDER_IDS: ["343537da-09a8-4b34-a1dd-06a1166ff871"],
  APP_SECRET:
    "0xcd48ed09ec9f71be8ba7231a223cdb208e9f816c8c0bc452433d7269a2f4f9e7",
};

export const RECLAIM_PROTOCOL_NO_TRANS = {
  APP_ID: "0xf17C4cbB1E2CeD8BA7ebC71aF90f868Eab1f571a",
  PROVIDER_IDS: ["d1872435-65a7-4034-afaf-1c31c8c6fbb2"],
  APP_SECRET:
    "0x56d2a77973af48a7bcf855cd5ea0ce38a02d4f92c1f6022d548db132e8bf1593",
};

export const RECLAIM_BANKS = {
  CANARA: "canara",
  SBI: "sbi",
};

const APP = {
  APP_ID: "0x0e3646FA3142c7E6D5AA0DbC4Cb801e443b45c64",
  APP_SECRET:
    "0x72eecb060bb78eea6597de2333f192f6834f2e1f67674acfe65d79ef17e5a15d",
};

const RECLAIM_PROVIDER_IDS = {
  V2: {
    SBI: {
      DBG_TRANS: "343537da-09a8-4b34-a1dd-06a1166ff873",
      NO_TRANS: "d1872435-65a7-4034-afaf-1c31c8c6fbb9",
    },
    CANARA: {
      DBG_TRANS: "bde57b98-fe99-4629-b2f3-95dcc9f79adb",
      NO_TRANS: "bde57b98-fe99-4629-b2f3-95dcc9f79adg",
    },
  },
};

export const RECLAIM_APPS = {
  SBI: {
    DBG_TRANS: {
      APP_ID: APP.APP_ID,
      PROVIDER_ID: RECLAIM_PROVIDER_IDS.V2.SBI.DBG_TRANS,
      APP_SECRET: APP.APP_SECRET,
    },
    NO_TRANS: {
      APP_ID: APP.APP_ID,
      PROVIDER_ID: RECLAIM_PROVIDER_IDS.V2.SBI.NO_TRANS,
      APP_SECRET: APP.APP_SECRET,
    },
  },
  CANARA: {
    DBG_TRANS: {
      APP_ID: APP.APP_ID,
      PROVIDER_ID: RECLAIM_PROVIDER_IDS.V2.CANARA.DBG_TRANS,
      APP_SECRET: APP.APP_SECRET,
    },
    NO_TRANS: {
      APP_ID: APP.APP_ID,
      PROVIDER_ID: RECLAIM_PROVIDER_IDS.V2.CANARA.NO_TRANS,
      APP_SECRET: APP.APP_SECRET,
    },
  },
};
